module.exports = __webpack_public_path__ + "media/_/_/node_modules/gateway_web_console/app/assets/images/emp-logo-big-ec704cb756761756fc879ce3ad79d14d.png";